import AvatarComponent from "./AvatarComponent";

export default AvatarComponent;
